export default __webpack_public_path__ + "static/media/MessinaSans-Regular.7e8671a8.woff2";